export const iconFontAwesomeMedicalHealthFileMedical = (
	<i className="fa-solid fa-file-medical"></i>
);
